export default __webpack_public_path__ + "static/Evisort-07e7629c6be3df33a84c6c973b5d9b35.jpeg";